import { CompleteStylistFragment } from 'drycut-graphql';
import { Stack } from 'ui-components';
import PauseButton from './PauseButton';
import { Transition } from '@headlessui/react';
import { Fragment } from 'react';
import StartButton from './StartButton';
import CheckOutButton from './CheckOutButton';

type Props = {
  stylist: CompleteStylistFragment;
  open: boolean;
};

export function StylistActions({ stylist, open }: Props): React.ReactElement {
  return (
    <Transition
      show={open}
      as={Fragment}
      enter="transition ease-out duration-200"
      enterFrom="opacity-0 translate-y-1"
      enterTo="opacity-100 translate-y-0"
      leave="transition ease-in duration-150"
      leaveFrom="opacity-100 translate-y-0"
      leaveTo="opacity-0 translate-y-1"
    >
      <div className="w-full transform" onClick={(event) => event.stopPropagation()}>
        <Stack gap={2}>
          <StartButton stylist={stylist} />
          <PauseButton stylist={stylist} />
          <CheckOutButton stylist={stylist} />
        </Stack>
      </div>
    </Transition>
  );
}
